module.exports = __webpack_public_path__ + "img/eprice-button.4f9158af.png";